'use strict';
const createChildElement = require('./create-child-element'),
	setElementVisibility = require('./set-element-visibility');

module.exports = function ensureElementIfNeeded(parentElement, tag, selector, shouldBeShown, initialAttributes) {
	if (!parentElement) {
		throw new Error('invalid-args');
	}
	const existing = parentElement.querySelector(selector);
	if (existing) {
		return setElementVisibility(existing, shouldBeShown);
	} else if (shouldBeShown) {
		return  createChildElement(parentElement, tag, initialAttributes);
	}

};
